import { APP_INITIALIZER, CUSTOM_ELEMENTS_SCHEMA, ErrorHandler, Injector, NgModule, Provider } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { RouteReuseStrategy } from '@angular/router';
import { IonicModule, IonicRouteStrategy } from '@ionic/angular';
import { AppComponent } from './app.component';
import { AppRoutingModule } from './app-routing.module';
import {
  HttpClient,
  HttpClientModule,
  HTTP_INTERCEPTORS,
} from '@angular/common/http';
import {
  TranslateLoader,
  TranslateModule,
  TranslateService,
} from '@ngx-translate/core';
import { AppService } from './core/services/app.service';
import { AppInterceptor } from './core/interceptors/app.interceptor';
import { AppServiceFactory } from './core/factories/app.factory';
import { createTranslateLoader, TranslationFactory } from './core/factories/translate.factory';
import { AuthInterceptor } from './core/interceptors/auth.interceptor';
import { LoadingInterceptor } from './core/interceptors/loading.interceptor';
import { Router } from '@angular/router';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { SchedulesReminderPageModule } from './shared/modals/schedules-reminder/schedules-reminder.module';
import { SharedModule } from './shared/shared.module';

// #region APP_INITIALIZER
const APP_INITIALIZERS: Provider[] = [
  AppService,
  {
    provide: APP_INITIALIZER,
    useFactory: AppServiceFactory,
    deps: [AppService],
    multi: true,
  },
  {
    provide: APP_INITIALIZER,
    useFactory: TranslationFactory,
    deps: [TranslateService, Injector],
    multi: true,
  },
];
// #endregion

// #region APP_INITIALIZER
const APP_INTERCEPTORS: Provider[] = [
  { provide: HTTP_INTERCEPTORS, useClass: AppInterceptor, multi: true },
  { provide: HTTP_INTERCEPTORS, useClass: AuthInterceptor, multi: true },
  { provide: HTTP_INTERCEPTORS, useClass: LoadingInterceptor, multi: true },
];
// #endregion

@NgModule({
  declarations: [AppComponent],
  imports: [
    BrowserModule,
    SharedModule,
    BrowserAnimationsModule,
    IonicModule.forRoot({
      mode: 'ios',
      innerHTMLTemplatesEnabled: true,
    }),
    AppRoutingModule,
    HttpClientModule,
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: createTranslateLoader,
        deps: [HttpClient],
      },
      isolate: false,
    }),
    SchedulesReminderPageModule,
  ],
  providers: [
    ...APP_INITIALIZERS,
    ...APP_INTERCEPTORS,
    { provide: RouteReuseStrategy, useClass: IonicRouteStrategy },
  ],
  bootstrap: [AppComponent],
})
export class AppModule { }
